/* STORMROCK — tiroir panier.
   1. Bande de paliers refaite (une barre, jalons cochés, ce que chacun débloque)
   2. Rail d'accessoires qui défile, sous les articles
   3. 19/09/2026 : le bloc « Obtenir 5 % supplémentaires » est SUPPRIMÉ, à la
      demande de Fabien. Ni mobile ni ordinateur ne l'affichent plus. Ne pas le
      remettre sans accord : le formulaire de numéro de téléphone était son seul
      moyen d'obtenir le code.
   4. Prix d'origine barré devant le total
   5. Bouton « Suivant » au lieu de « Finaliser le paiement »
   Le tiroir est re-rendu par le thème à chaque changement de panier : tout est
   réinjecté par un MutationObserver, et chaque pose est idempotente. */
(function () {
  'use strict';

  /* ---- réglages ---- */
  var ACCESSOIRES = [
    'grinder-stormrock',
    'briquet-type-zippo-stormrock',
    'feuilles-slim-stormrock-1',
    'cendrier-verre-stormrock',
    'etuis-pre-rolls-stormrock',
    'plateau-stormrock'
  ];
  /* Remise affichée sur le rail. 0 = aucune remise affichée.
     Ne la passer à 0.3 QUE lorsque la réduction automatique correspondante
     existe côté boutique, sinon le prix affiché ne serait pas celui payé. */
  var REMISE_ACCESSOIRES = 0;

  /* Ce que débloque chaque palier.
     19/09/2026 : le nom du palier est désormais porté par le markup, dans
     l'attribut data-sr-label que pose snippets/cart-progress.liquid depuis les
     réglages du thème. Cette table ne sert plus que de repli, pour un thème où
     le snippet n'aurait pas encore été mis à jour. Les montants réels sont
     49 € livraison, 59 € 5 g, 79 € 10 g, 99 € pack goodies. */
  var PALIERS = {
    '49': 'Livraison offerte',
    '59': '5 g offerts',
    '79': '10 g offerts',
    '99': 'Pack goodies'
  };

  var CTA = 'Suivant';

  /* ---- utilitaires ---- */
  function euro(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }
  /* Montant de palier : les centimes n'apportent rien sous un jalon, et la
     colonne est étroite en mobile. 4900 -> « 49 € », 4950 -> « 49,50 € ». */
  function euroCourt(cents) {
    var v = cents / 100;
    var t = v % 1 === 0 ? String(v) : v.toFixed(2).replace('.', ',');
    return t + ' €';
  }
  function parseEuro(txt) {
    var m = String(txt || '').replace(/\s/g, '').match(/([\d.,]+)/);
    if (!m) return null;
    return Math.round(parseFloat(m[1].replace(/\./g, '').replace(',', '.')) * 100);
  }
  function el(html) {
    var d = document.createElement('div');
    d.innerHTML = html.trim();
    return d.firstElementChild;
  }

  /* ---- 1. paliers ---- */
  function paliers(root) {
    var old = root.querySelector('.cart-progress');
    if (!old || root.querySelector('.srx-prog')) return;

    /* innerHTML et non textContent : la phrase vient de notre propre snippet
       snippets/cart-progress.liquid, qui enrobe le montant manquant dans un
       <span class="missing-value"> — on le garde pour le surligner. */
    var source = old.querySelector('.cart-progress__message');
    var message = source ? source.innerHTML : '';
    var groupes = [].slice.call(old.querySelectorAll('.progress-group'));
    var etapes = groupes.map(function (g) {
      var bar = g.querySelector('progress');
      var montant = parseEuro(g.textContent);
      var cle = montant !== null ? String(Math.round(montant / 100)) : '';
      return {
        montant: montant,
        titre: g.getAttribute('data-sr-label') || PALIERS[cle] || '',
        valeur: bar ? Number(bar.value) : 0,
        atteint: bar ? Number(bar.value) >= Number(bar.max || 100) : false
      };
    }).filter(function (e) { return e.montant !== null; });

    if (!etapes.length) return;

    /* Échelle par ÉTAPES ÉGALES, pas au prorata des euros.
       Avec 49 / 59 / 79 / 99 €, une échelle proportionnelle tasserait les trois
       premiers jalons entre 49 % et 80 % de la barre : illisible, et les noms
       ne pourraient plus être alignés dessous. Chaque palier occupe donc un
       segment de même largeur, et le jalon se pose au centre de sa colonne de
       légende — repère et nom sont ainsi toujours l'un au-dessus de l'autre.

       Le remplissage vaut le nombre de paliers franchis, plus l'avancement
       dans le palier en cours (progress.value, calculé en Liquid). L'ancien
       calcul multipliait ce pourcentage par la part du palier dans le total :
       juste pour le premier palier seulement, faux pour les suivants. */
    var nb = etapes.length;
    var faits = etapes.filter(function (e) { return e.atteint; }).length;
    var courant = etapes[Math.min(faits, nb - 1)];
    var dans = faits >= nb ? 0 : Math.max(0, Math.min(100, courant.valeur)) / 100;
    var remplissage = Math.round(((faits + dans) / nb) * 100);
    remplissage = Math.max(0, Math.min(100, remplissage));

    var jalons = etapes.map(function (e, i) {
      var x = ((i + 0.5) / nb) * 100;
      var cls = 'srx-prog__mark';
      if (e.atteint) cls += ' srx-prog__mark--done';
      else if (i === faits) cls += ' srx-prog__mark--next';
      return '<span class="' + cls + '" style="left:' + x.toFixed(2) + '%">' +
        (e.atteint ? '✓' : String(i + 1)) + '</span>';
    }).join('');

    var legende = etapes.map(function (e, i) {
      var cls = 'srx-prog__step';
      if (e.atteint) cls += ' srx-prog__step--done';
      else if (i === faits) cls += ' srx-prog__step--next';
      return '<li class="' + cls + '">' +
        '<b>' + euroCourt(e.montant) + '</b>' +
        (e.titre ? '<em>' + e.titre + '</em>' : '') + '</li>';
    }).join('');

    var bloc = el(
      '<div class="srx-prog" style="--srx-n:' + nb + '">' +
      '<p class="srx-prog__msg">' + message + '</p>' +
      '<div class="srx-prog__track">' +
      '<span class="srx-prog__fill" style="width:' + remplissage + '%"></span>' +
      jalons + '</div>' +
      '<ul class="srx-prog__legend">' + legende + '</ul></div>'
    );
    old.parentNode.insertBefore(bloc, old);
  }

  /* ---- 2. rail d'accessoires ---- */
  var cacheProduits = null;

  /* « Briquet STORMROCK - Style ZIPPO » -> « Briquet » : les cartes du rail sont
     étroites, on garde le nom de l'objet et rien d'autre. */
  function nettoyerTitre(t) {
    return String(t || '')
      .replace(/stormrock/ig, '')
      .replace(/\s*[-–—(].*$/, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function chargerAccessoires() {
    if (cacheProduits) return Promise.resolve(cacheProduits);
    return Promise.all(ACCESSOIRES.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (liste) {
      cacheProduits = liste.filter(Boolean).map(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
        return {
          id: v.id,
          titre: nettoyerTitre(p.title),
          prix: v.price,
          image: p.featured_image || (p.images && p.images[0]) || ''
        };
      });
      return cacheProduits;
    });
  }

  function ajouter(id, bouton) {
    bouton.disabled = true;
    bouton.textContent = 'Ajout…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function () {
      window.location.reload();
    }).catch(function () {
      bouton.disabled = false;
      bouton.textContent = 'Ajouter';
    });
  }

  /* 19/09/2026, retour en arrière assumé : le rail avait été remonté dans le
     résumé, juste au-dessus du code de réduction. Sur mobile le résumé est
     collé en bas et ne défile pas : le rail y prenait presque toute la hauteur
     et les articles du panier disparaissaient. Il reste donc dans la zone qui
     défile, sous les articles, avec des marges resserrées. */
  function rail(root) {
    var ancre = root.querySelector('scroll-hint') || root.querySelector('.cart-items__wrapper');
    if (!ancre || root.querySelector('.srx-acc')) return;

    var bloc = el(
      '<div class="srx-acc"><div class="srx-acc__head">' +
      '<p class="srx-acc__kicker">Complète ta commande</p>' +
      (REMISE_ACCESSOIRES ? '<span class="srx-acc__tag">−' + Math.round(REMISE_ACCESSOIRES * 100) + ' %</span>' : '') +
      '</div><ul class="srx-acc__rail"></ul></div>'
    );
    ancre.appendChild(bloc);

    chargerAccessoires().then(function (produits) {
      var ul = bloc.querySelector('.srx-acc__rail');
      if (!ul || ul.children.length) return;
      produits.forEach(function (p) {
        var remise = REMISE_ACCESSOIRES ? Math.round(p.prix * (1 - REMISE_ACCESSOIRES)) : p.prix;
        var li = el(
          '<li class="srx-acc__card">' +
          '<div class="srx-acc__media"><img src="' + p.image + '&width=240" alt="" loading="lazy"></div>' +
          '<p class="srx-acc__title">' + p.titre + '</p>' +
          '<p class="srx-acc__price">' +
          (REMISE_ACCESSOIRES ? '<s>' + euro(p.prix) + '</s>' : '') +
          '<b>' + euro(remise) + '</b></p>' +
          '<button type="button" class="srx-acc__add">Ajouter</button></li>'
        );
        li.querySelector('.srx-acc__add').addEventListener('click', function () {
          ajouter(p.id, this);
        });
        ul.appendChild(li);
      });
    });
  }

  /* ---- 3. bloc +5 % : supprimé le 19/09/2026 ----
     La fonction bonus() et son appel sont retirés. Par sécurité, si un ancien
     rendu mis en cache posait encore le bloc, on le retire du tiroir. */
  function purgerBonus(root) {
    var restes = root.querySelectorAll('.srx-bonus');
    for (var i = 0; i < restes.length; i++) {
      if (restes[i].parentNode) restes[i].parentNode.removeChild(restes[i]);
    }
  }

  /* ---- 4. prix d'origine barré ---- */
  function totalBarre(root) {
    var total = root.querySelector('.cart__total-value');
    var economies = root.querySelector('.cart__savings-value');
    if (!total || !economies) return;
    var conteneur = total.parentNode;
    if (!conteneur || conteneur.querySelector('.srx-was')) return;
    var t = parseEuro(total.textContent), e = parseEuro(economies.textContent);
    if (t === null || e === null || e <= 0) return;
    var span = el('<span class="srx-was">' + euro(t + e) + '</span>');
    conteneur.insertBefore(span, total);
  }

  /* ---- 5. libellé du bouton ---- */
  function bouton(root) {
    var t = root.querySelector('.cart__checkout-button .button__text');
    if (t && t.textContent.trim() !== CTA) t.textContent = CTA;
  }

  /* ---- orchestration ---- */
  function poser() {
    var root = document.querySelector('cart-drawer-component');
    if (!root) return;
    try { paliers(root); } catch (e) {}
    try { rail(root); } catch (e) {}
    try { purgerBonus(root); } catch (e) {}
    try { totalBarre(root); } catch (e) {}
    try { bouton(root); } catch (e) {}
  }

  function demarrer() {
    poser();
    if (!window.MutationObserver) return;

    /* 19/09/2026 : on surveillait document.body en profondeur. Tout le bruit du
       site passait par là — le re-rendu de la fiche à chaque changement de
       format, les recommandations, les fenêtres des applications tierces — soit
       une quinzaine de réveils par clic alors que le tiroir panier n'avait pas
       bougé. On surveille désormais le seul tiroir. S'il n'est pas encore là,
       on attend son arrivée en ne regardant que les enfants directs du corps de
       page, sans descendre dans l'arbre. */
    var minuteur = null;
    function replanifier() {
      clearTimeout(minuteur);
      minuteur = setTimeout(poser, 120);
    }

    function surveillerTiroir() {
      var tiroir = document.querySelector('cart-drawer-component');
      if (!tiroir || tiroir.dataset.srCartVu) return !!tiroir;
      tiroir.dataset.srCartVu = '1';
      new MutationObserver(replanifier).observe(tiroir, { childList: true, subtree: true });
      replanifier();
      return true;
    }

    if (!surveillerTiroir()) {
      var attente = new MutationObserver(function () {
        if (surveillerTiroir()) attente.disconnect();
      });
      attente.observe(document.body, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
